import React from 'react'

export const USER_STATE_UNRESOLVED = 'unresolved'
export const USER_STATE_INVALID = 'invalid'
export const USER_STATE_OK = 'ok'

export const defaultValue = {
  data: null,
  status: USER_STATE_UNRESOLVED,
  isEnabled: () => false,
}

export const EndUserContext = React.createContext(defaultValue)
